import { makeStyles, Typography, useTheme } from '@material-ui/core';
import React from 'react';
import { styles } from './page.styles';

export interface PageLeftColumnProps {
  title?: string | undefined;
}

const PageLeftColumn: React.FC<PageLeftColumnProps> = ({ title, ...props }) => {
  const currentTheme = useTheme();
  const useStyles = makeStyles(styles(currentTheme));
  const classes = useStyles();

  return (
    <div className={classes.leftColumn}>
      {title && (
        <div className={classes.columnHeader}>
          <Typography variant="h1" color="primary">
            {title}
          </Typography>
        </div>
      )}

      {props.children}
    </div>
  );
};

export default PageLeftColumn;
